<template>
  <div>
    <v-autocomplete
      :label="label"
      :color="color"
      :multiple="multiple"
      :outlined="outlined"
      dense
      hide-details="auto"
      v-model="selectedItems"
      :items="items"
      :bind="$props"
      :error-messages="errorMessages"
    >
      <template v-slot:selection="data">
        <v-chip v-if="data.item.entireObject != undefined && data.item.entireObject[dependentEntityKey] != null"
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.select"
          @click:close="detachItem(data.item)"
          pill
          small
        >
          {{ data.item.text }}
        </v-chip>
        <v-chip v-else
          v-bind="data.attrs"
          :input-value="data.selected"
          pill
          small
        >
          {{ data.item.text}}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <span class="text-body-1">{{ data.item.text }}</span>
      </template>
    </v-autocomplete>

  </div>
</template>

<script>
import httpClient from '@/api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
    data () {
      return {
        select: {
          items: []
        },
        selectedItems: null,
      }
    },
    props: {
      items: Array,
      detachItemEndpoint: {
        type: String,
        default: ""
      },
      label: {
        type: String,
        default: translate('Select item', 'fields')
      },
      color: {
        type: String,
        default: 'primary'
      },
      value: {
        type: Number | Array,
        default: 0
      },
      multiple: {
        type: Boolean,
        default: false
      },
      clearData: {
        type: Number,
        default: 0
      },
      outlined: {
        type: Boolean,
        default: true
      },
      errorMessages: {
        type: Array,
        required: false
      },
      dependentEntityKey: {
        type: String,
        default: ""
      },
    },
    methods: {
      detachItem (item) {
        if(item.value != 0) {
          item.entireObject[this.dependentEntityKey] = null
          this.selectedItems = null

        }
      },
    },
    watch: {
      selectedItems: {
        handler() {
          this.$emit('input', this.selectedItems)
        }
      },
      value: {
        handler() {
          this.selectedItems = this.value
        }
      },
      clearData: {
        handler() {
          if (this.clearData) {
            this.selectedItems = []
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
.v-list-item {
  min-height: 30px !important;
}

.v-application .text-caption {
  font-size: 0.65rem !important;
}

.v-application .text-body-1 {
  font-size: 0.9rem !important;
}

.v-application .text-body-2 {
  font-size: 0.8rem !important;
}
</style>
